import StampOrVirtualStampFormItem from '../../components/calculation-form/components/form-items/stamp-or-virtual-stamp-form-item'
import StampNumber from '../../components/calculation-form/components/other/stamp-number'
import VirtualStampNumber from '../../components/calculation-form/components/other/virtual-stamp-number'
import { renderCalcPos, VIRTUAL_STAMP_FIELD_DESCRIPTORS } from '../../helpers/helpers'
import isCalculation from '../../helpers/is-calculation'
import type { DataSourceItem } from '../../helpers/convert-calculations-to-data-source'
import type { CalculationColumn } from '../../types/column-types'

export const stampIdColumn: CalculationColumn = {
    dataIndex: ['stamp', 'number'],
    relationPath: ['stamp'],
    title: 'Штамп',
    width: 74,
    editable: true,
    FormItem: <StampOrVirtualStampFormItem />,
    render: renderCalcPos((r, v) => {
        return r.withoutCutting ? <VirtualStampNumber data={r} /> : <StampNumber data={r} />
    }),
    onCell: (record: DataSourceItem) => {
        if (isCalculation(record)) {
            return { colSpan: 0 }
        }
        return {
            colSpan: 1,
            dataIndex: record.withoutCutting ? ['virtualStamp'] : ['stamp'],
            ...(record.withoutCutting ? { fieldDescriptors: VIRTUAL_STAMP_FIELD_DESCRIPTORS } : {}),
        }
    },
}
